import React, { useState, useEffect, useRef } from "react"
import { getToken } from "../../firebaseInit.js"

async function postData(url = "", data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  })
  return response.json() // parses JSON response into native JavaScript objects
}

// FOR BACKGROUND NOTIFICATION AND GET TOKEN
const FirebaseNotifications = props => {
  const [isTokenFound, setTokenFound] = useState(false)
  const hasSyncedRef = useRef(false)
  console.log("Token found", isTokenFound)

  useEffect(() => {
    let intervalId

    const syncTokenWithUser = async () => {
      try {
        const token = await getToken(setTokenFound) // Fetch token once

        const trySendToken = async () => {
          const authUser = JSON.parse(localStorage.getItem("authUser"))

          if (authUser?.PhoneNumber && token && !hasSyncedRef.current) {
            await postData(`${process.env.REACT_APP_ADMIN}/login/update/fcm`, {
              PhoneNumber: authUser.PhoneNumber,
              Token: token,
            })

            hasSyncedRef.current = true // Prevent repeat submissions
            clearInterval(intervalId) // Clean up
          }
        }

        // First immediate attempt
        trySendToken()

        // Set retry loop only if needed
        intervalId = setInterval(trySendToken, 10000)
      } catch (error) {
        console.error("Failed to sync FCM token:", error)
      }
    }

    syncTokenWithUser()

    return () => {
      if (intervalId) clearInterval(intervalId)
    }
  }, [isTokenFound])
  return <></>
}

FirebaseNotifications.propTypes = {}

export default FirebaseNotifications
